import {styled} from '../../utils';
import {FlexProps} from './types';

const Flex = styled('div')<FlexProps>(({inline, center, align, justify, direction, wrap, order}) => ({
  boxSizing: 'border-box',
  display: inline ? 'inline-flex' : 'flex',
  alignItems: center ? 'center' : align,
  justifyContent: center ? 'center' : justify,
  flexDirection: direction || 'row',
  flexWrap: wrap || 'nowrap',
  order
}));

export default Flex;



// WEBPACK FOOTER //
// ./src/components/Flex/Flex.tsx